import img from '../../../img/desert1.svg'
import img2 from '../../../img/desert2.svg'
import img3 from '../../../img/desert3.svg'
import img4 from '../../../img/desert4.svg'
import img5 from '../../../img/pizza1.svg'

export const snackData = [
    {
        img: img,
        name: 'Филадельфия кранч',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'snick#1'
    },

    {
        img: img2,
        name: 'Филадельфия крем-брюле',
        text: 'Сливочный сыр, семга татаки с тростниковым сахаром, соус у...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'snick#2'
    },
    {
        img: img3,
        name: 'Супер Филадельфия',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'snick#3'
    },
    {
        img: img4,
        name: 'Тигр мама',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'snick#4'
    },
    {
        img: img4,
        name: 'Тигр мама',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'snick#5'
    },
    {
        img: img3,
        name: 'Супер Филадельфия',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'snick#6'
    },
    {
        img: img5,
        name: 'Филадельфия крем-брюле',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'snick#7'
    },
    {
        img: img5,
        name:'Филадельфия крем-брюле',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'snick#8'
    },
]